function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import { getCookie } from '../helpers';
var jwt = "";
var myHeaders = new Headers();
var ctHeaders = new Headers();
var depId = '';
var settings;
export var FetchWrapper = {
  init: function init(params) {
    settings = params;
  },
  fetchData: getData,
  fetchEmployees: getEmployees,
  fetchCountries: getCountries,
  fetchDepartment: getDept,
  editEmployee: editUser,
  removeEmployee: removeUser,
  sendInv: sendInvitation,
  resetPassword: resetPassword
};

// get jwt from cookie
// if not, show auth popup and redirect to login page
function getJwt() {
  return new Promise(function (resolve) {
    var cookie = getCookie('OneIdTempCookie');
    if (cookie == "") {
      throw 'Auth_error';
    }
    var cookie_obj = JSON.parse('{"' + decodeURI(cookie).replace(/&/g, '","').replace(/=/g, '":"') + '"}');
    if (cookie_obj.OneIdTokenValue == "" || cookie_obj.OneIdAccessTokenValue == "") {
      throw 'Auth_error';
    }
    resolve(cookie_obj.OneIdAccessTokenValue);
  });
}

// getting data from server first time
function getData() {
  if (settings.debug) console.log('gettin first time data ');
  return getJwt().then(function (data) {
    jwt = data;
    if (settings.debug) console.log('jwt: ', jwt);
    myHeaders.append('Authorization', 'Bearer ' + jwt);
    ctHeaders.append('Authorization', 'Bearer ' + jwt);
    ctHeaders.append('Content-Type', 'application/json');
    return getDept();
  });
}
function getDept() {
  if (settings.debug) console.log('getin dept ');
  return fetch(settings.ApiBaseUrl + '/organizations/admin/me', {
    method: 'GET',
    headers: myHeaders
  }).then(function (response) {
    return resStatus(response);
  }).then(function (data) {
    depId = data.organizations[0].departments[0].id;
    var searchParams = {
      page: 1,
      size: settings.UserListSize,
      search: ''
    };
    return getEmployees(searchParams);
  }).catch(function (error) {
    if (settings.debug) console.log("can't get depid: ", error);
    throw error;
  });
}
function getCountries(_x) {
  return _getCountries.apply(this, arguments);
}
function _getCountries() {
  _getCountries = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(args) {
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          if (settings.debug) console.log('gettin countries for iscode ' + settings.CountryCode);
          return _context.a(2, fetch(settings.ApiBaseUrl + '/datalocation/countries?cultureCode=' + settings.CountryCode, {
            headers: myHeaders
          }).then(function (response) {
            return resStatus(response);
          }).catch(function (error) {
            if (settings.debug) console.log("can't get countries: ", error);
            throw error;
          }));
      }
    }, _callee);
  }));
  return _getCountries.apply(this, arguments);
}
function getEmployees(_x2) {
  return _getEmployees.apply(this, arguments);
}
function _getEmployees() {
  _getEmployees = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(args) {
    var params;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          if (settings.debug) console.log('getin employees ');
          params = args ? '?' + Object.keys(args).map(function (key) {
            return key + '=' + args[key];
          }).join('&') : '';
          if (settings.debug) console.log(params);
          return _context2.a(2, fetch(settings.ApiBaseUrl + '/department/' + depId + '/employees' + params, {
            headers: myHeaders
          }).then(function (response) {
            return resStatus(response);
          }).catch(function (error) {
            if (settings.debug) console.log("can't get employees: ", error);
            throw error;
          }));
      }
    }, _callee2);
  }));
  return _getEmployees.apply(this, arguments);
}
function editUser(_x3, _x4, _x5, _x6) {
  return _editUser.apply(this, arguments);
}
function _editUser() {
  _editUser = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(userId, fname, lname, countrycode) {
    var postBody;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          if (settings.debug) console.log('countrycode: ', countrycode);
          //TODO REMOVE AFTER DATA LOCATION IS LIVE
          postBody = '';
          if (settings.UseDataLocation) {
            postBody = JSON.stringify({
              "firstName": fname,
              "lastName": lname,
              "middleName": "",
              "countryCode": countrycode
            });
          } else {
            postBody = JSON.stringify({
              "firstName": fname,
              "lastName": lname,
              "middleName": ""
            });
          }
          if (settings.debug) console.log("Edit user body", postBody);
          return _context3.a(2, fetch(settings.ApiBaseUrl + '/person/' + userId, {
            method: 'POST',
            headers: ctHeaders,
            body: postBody
          }).then(function (response) {
            return resStatus(response);
          }).catch(function (error) {
            if (settings.debug) console.log("can't edit user: ", error);
            throw error;
          }));
      }
    }, _callee3);
  }));
  return _editUser.apply(this, arguments);
}
function removeUser(userId, invitationId) {
  if (settings.debug) console.log('remove cilent: ', userId);
  if (settings.debug) console.log('userid', userId);
  if (settings.debug) console.log('invitationid', invitationId);
  if (userId != null) {
    return fetch(settings.ApiBaseUrl + '/department/' + depId + '/employee/' + userId, {
      method: 'DELETE',
      headers: myHeaders
    }).then(function (response) {
      return resStatus(response);
    }).catch(function (error) {
      if (settings.debug) console.log("can't remove employee: ", error);
      throw error;
    });
  } else {
    if (settings.debug) console.log('Calling for deleting invitation', invitationId);
    return fetch(settings.ApiBaseUrl + '/department/' + depId + '/invitation/' + invitationId, {
      method: 'DELETE',
      headers: myHeaders
    }).then(function (response) {
      return resStatus(response);
    }).catch(function (error) {
      if (settings.debug) console.log("can't remove invitation: ", error);
      throw error;
    });
  }
}
function getHeaders() {
  var headers = new Headers();
  headers.append('Content-Type', 'application/json');
  return headers;
}
function resetPassword(email, loggedIn) {
  if (settings.debug) console.log('reset password for: ', email);
  return fetch(settings.ApiBaseUrl + '/passwordreset', {
    method: 'POST',
    headers: loggedIn ? ctHeaders : getHeaders(),
    body: JSON.stringify({
      "email": email,
      "tenant": settings.TenantName + '.' + settings.TenantDomain,
      "redirectUrl": settings.RedirectUrl,
      "redirectUrn": "",
      "emailRedirectUrn": "",
      "clientId": settings.ClientId,
      "cultureCode": settings.CultureCode,
      "state": settings.LoginUrl
    })
  }).then(function (response) {
    return resStatus(response);
  }).catch(function (error) {
    if (settings.debug) console.log("can't reset password: ", error);
    throw error;
  });
}
function sendInvitation(emails) {
  for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    params[_key - 1] = arguments[_key];
  }
  if (settings.debug) console.log('sending invitation ', emails, params);
  var promises = emails.map(function (email) {
    return fetch(settings.ApiBaseUrl + '/department/' + depId + '/invitation', {
      method: 'POST',
      headers: ctHeaders,
      body: JSON.stringify({
        "email": email,
        "tenant": settings.TenantName + '.' + settings.TenantDomain,
        "redirectUrl": settings.RedirectUrl,
        "redirectUrn": "",
        "emailRedirectUrn": "",
        "clientId": settings.ClientId,
        "cultureCode": settings.CultureCode,
        "state": settings.PostRegisterPageUrl,
        "parameters": {
          "MESSAGE_DEFAULT": params[0],
          "MESSAGE_PERSONAL": params[1]
        }
      })
    }).then(function (response) {
      return resStatus(response);
    }).catch(function (error) {
      if (settings.debug) console.log("can't send inv: ", error);
      throw error;
    });
  });
  return Promise.all(promises);
}
function resStatus(response) {
  if (settings.debug) console.log(response);
  if (response.status === 401) {
    // show authorize popup
    throw 'Auth_error';
  }
  if (response.status >= 200 && response.status <= 204) {
    return response.text().then(function (text) {
      return text ? JSON.parse(text) : {};
    });
  }
  throw "Server_error";
}